import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  eightyPercentOfLimitReached: {
    description: 'Shipping limit warning message when 80% of the shipping limit has been reached',
    defaultMessage:
      "<b>You've used {percentage}% of your current plan's monthly shipment limit ({current} of {limit}).</b> <button>View Plans</button>",
    id: 'rp8ken',
  },
  ninetyFivePercentOfLimitReached: {
    description: 'Shipping limit warning message when 95% of the shipping limit has been reached',
    defaultMessage:
      "<b>You've used {percentage}% of your current plan's monthly shipment limit ({current} of {limit}). Upgrade your plan to avoid interruptions.</b> <button>Upgrade Now</button>",
    id: 'YJsp61',
  },
  monthlyLimitReached: {
    description: 'Shipping limit error message when the shipping limit has been reached',
    defaultMessage: "<b>You've reached your monthly shipment limit. {current} of {limit}</b> <button>Upgrade to keep shipping</button>",
    id: '47VD3G',
  },
  zeroShipmentLimit: {
    description: 'Message for free plan users with 0 shipment limit',
    defaultMessage: '<b>Your plan includes 0 shipments. Upgrade to start shipping.</b> <button>View Plans</button>',
    id: '/d4Nhc',
  },
});
